module.exports = "/assets/data/1ddc7777f9cebb56c1827b145b89534c-BS21.data.json";